import styled from 'styled-components';

import { CARD_OPENING_TRANSITION_DURATION } from '#@/shared/constants';
import { COLOR, mediaQueries } from '#@/shared/utils/styles';
import { zIndexValues } from '#@/shared/utils/styles/zIndexValues';

export interface MobileBackgroundProps {
  isOpen: boolean;
}

const MobileBackground = styled.div<MobileBackgroundProps>`
  pointer-events: ${(props) => (props.isOpen ? 'auto' : 'none')};
  z-index: ${zIndexValues.overlayElement};

  @media ${mediaQueries.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: ${COLOR.modalOverlay};
    cursor: pointer; /* Without this, closing the overlay does not work on iOS */
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    transition: opacity ${CARD_OPENING_TRANSITION_DURATION}ms;
  }
`;

export default MobileBackground;
